import {schema} from 'normalizr'

export const individual = new schema.Entity('individuals');
export const individualList = new schema.Array(individual);

export const address = new schema.Entity('addresses');
export const addressList = new schema.Array(address);

export const careService = new schema.Entity('careServices');
export const careServiceList = new schema.Array(careService);

export const nurseCareService = new schema.Entity('nurseCareServices');
export const nurseCareServiceList = new schema.Array(nurseCareService);

nurseCareService.define({
    careService,
});

individual.define({
    address,
    careServices: nurseCareServiceList
});



// WEBPACK FOOTER //
// ./src/entities/schema.js